import ControlledDocList from '../../../components/HSEQ/ControlledDocuments/ControlledDocList'
import ControlledDocModal from '../../../components/HSEQ/ControlledDocuments/ControlledDocModal'
import PageTitle from '../../../elements/PageTitle'
import { Breadcrumb, Card, Layout, Row } from 'antd'
import React, { Fragment } from 'react'

const { Content } = Layout

function ControlledDoc(props) {
  return (
    <Fragment>
      <Content style={{ margin: '0px 0px' }}>
        <Card>
          <Row>
            <Breadcrumb>
              <Breadcrumb.Item href="/HSEQ">HSEQ</Breadcrumb.Item>
              <Breadcrumb.Item>Controlled Document</Breadcrumb.Item>
            </Breadcrumb>
            <PageTitle
              title={'Controlled Document'}
              subtitle={'Manage Controlled Documents'}
              color={'#FF6138'}
              iconType={'file-pdf'}
            />
          </Row>
        </Card>
        <Row gutter={16} style={{ padding: 10 }}>
          <Card>
            <ControlledDocModal {...props} />
            <ControlledDocList {...props} />
          </Card>
        </Row>
      </Content>
    </Fragment>
  )
}

ControlledDoc.propTypes = {}
ControlledDoc.defaultProps = {}

export default ControlledDoc
